import Vue from "vue";
import Router from "vue-router";
import AppHeader from "./components/AppHeader";
import AppFooter from "./components/AppFooter";
import AppLogin from "./components/AppLogin";
import AppLanding from "./components/AppLanding";
import ParkingConfirmation from "./components/ParkingConfirmation";
import PassengersConfirmation from "./components/PassengersConfirmation";

Vue.use(Router);

let router = new Router({
  // linkExactActiveClass: "active",
  routes: [
    {
      path: "/",
      name: "AppLanding",
      components: {
        header: AppHeader,
        default: AppLanding,
        footer: AppFooter
      }
    },
    {
      path: "/login",
      name: "AppLogin",
      components: {
        header: AppHeader,
        default: AppLogin,
        footer: AppFooter
      }
    },
    {
      path: "/passengersConfirmation",
      name: "PassengersConfirmation",
      components: {
        header: AppHeader,
        default: PassengersConfirmation,
        footer: AppFooter
      }
    },
    {
      path: "/parkingConfirmation",
      name: "ParkingConfirmation",
      components: {
        header: AppHeader,
        default: ParkingConfirmation,
        footer: AppFooter
      }
    }
  ]
});

export default router;
